/**
 * Familiarisation Checklist Templates
 * Built-in templates for common use cases
 */

// Section preset definitions
export const SECTION_PRESETS = {
  PRE_SAILING: {
    id: 'pre_sailing',
    name: 'Pre-Sailing Familiarisation',
    description: 'Essential safety briefing before vessel departure',
    order: 1
  },
  EMERGENCY: {
    id: 'emergency_equipment',
    name: 'Emergency Equipment & Procedures',
    description: 'Emergency response equipment and procedures',
    order: 2
  },
  VESSEL_SYSTEMS: {
    id: 'vessel_systems',
    name: 'Vessel Systems & Controls',
    description: 'Main vessel systems and operational controls',
    order: 3
  },
  TASK_SPECIFIC: {
    id: 'task_specific',
    name: 'Task-Specific Familiarisation',
    description: 'Job and task specific requirements',
    order: 4
  },
  ROLE_SPECIFIC: {
    id: 'role_specific',
    name: 'Role-Specific Procedures',
    description: 'Position-specific duties and responsibilities',
    order: 5
  }
};

// Contractor template - safety essentials only
export const CONTRACTOR_TEMPLATE = {
  id: 'fcl_contractor',
  name: 'Contractor Safety Briefing',
  type: 'contractor',
  isDefault: false,
  isSystem: true,  // Built-in, but can be customized
  validityPeriodMonths: 0,  // No expiry - one-time briefing
  appliesTo: {
    positions: ['contractor', 'visitor'],
    departments: []
  },
  sections: [
    {
      id: 'emergency_procedures',
      name: 'Emergency Procedures',
      order: 1,
      items: [
        { id: 'con_muster_point', text: 'Muster point location', required: true, regulation: 'ISM 8.1', isCustom: false },
        { id: 'con_alarm_signals', text: 'Emergency alarm signals and meanings', required: true, regulation: 'ISM 8.1', isCustom: false },
        { id: 'con_lifejacket', text: 'Lifejacket location and donning procedure', required: true, regulation: 'WBC3 App 8', isCustom: false },
        { id: 'con_fire_extinguisher', text: 'Fire extinguisher locations', required: true, regulation: 'WBC3 App 8', isCustom: false },
        { id: 'con_escape_routes', text: 'Emergency escape routes', required: true, regulation: 'ISM 8.1', isCustom: false },
        { id: 'con_mob_basics', text: 'Man overboard - raise alarm, throw lifebuoy', required: true, regulation: 'WBC3 App 8', isCustom: false }
      ]
    },
    {
      id: 'safety_rules',
      name: 'Safety Rules',
      order: 2,
      items: [
        { id: 'con_ppe', text: 'PPE requirements while on board', required: true, regulation: 'Company', isCustom: false },
        { id: 'con_restricted', text: 'Restricted areas - do not enter without permission', required: true, regulation: 'Company', isCustom: false },
        { id: 'con_hazard_report', text: 'How to report hazards or concerns', required: true, regulation: 'ISM 9', isCustom: false },
        { id: 'con_smoking', text: 'Smoking policy and designated areas', required: true, regulation: 'Company', isCustom: false },
        { id: 'con_emergency_contact', text: 'Emergency contact - Skipper/Master location', required: true, regulation: 'Company', isCustom: false },
        { id: 'con_acknowledgment', text: 'Briefing acknowledgment and questions', required: true, regulation: 'Company', isCustom: false }
      ]
    }
  ],
  customItems: [],
  editedItems: {},
  deletedItems: [],
  createdAt: null,  // Set on migration
  updatedAt: null
};

// Template types
export const TEMPLATE_TYPES = {
  CREW: { id: 'crew', label: 'Crew Familiarisation', description: 'Full familiarisation for permanent crew members' },
  CONTRACTOR: { id: 'contractor', label: 'Contractor/Visitor', description: 'Short safety briefing for visitors' },
  CUSTOM: { id: 'custom', label: 'Custom', description: 'Build your own template' }
};

// Default validity options
export const VALIDITY_OPTIONS = [
  { value: 0, label: 'No expiry' },
  { value: 6, label: '6 months' },
  { value: 12, label: '12 months (default)' },
  { value: 18, label: '18 months' },
  { value: 24, label: '24 months' },
  { value: 36, label: '36 months' },
  { value: 'custom', label: 'Custom...' }
];
